import { combineReducers, configureStore, AnyAction } from '@reduxjs/toolkit'
import userSlice from './userSlice'
import studentClassroomSlice from './student/studentClassroomsSlice'
import lessonsSlice from './student/lessonsSlice'
import dailyBeatsSlice from './student/dailyBeatsSlice'
import miscSlice from './miscSlice'
import classroomsSlice from './teacher/classroomsSlice'
import schoolsSlice from './admin/schoolsSlice'
import districtsSlice from './admin/districtsSlice'
import teachersSlice from './admin/teachersSlice'
import districtSlice from './districtAdmin/districtSlice'
import districtSchoolsSlice from './districtAdmin/schoolsSlice'
import districtTeachersSlice from './districtAdmin/teachersSlice'
import studentsSlice from './teacher/studentsSlice'
import focusSeshSlice from './student/focusSeshSlice'
import focusSeshPresetsSlice from './student/focusSeshPresetsSlice'
import focusSeshLogsSlice from './student/focusSeshLogsSlice'
import aiChatThreadSlice from './teacher/aiChatThreadSlice'

export const ROOT_ACTIONS = {
  RESET: { type: 'RESET' },
} as const

const combinedReducer = combineReducers({
  // Student:
  user: userSlice,
  studentClassrooms: studentClassroomSlice,
  dailyBeats: dailyBeatsSlice,
  lessons: lessonsSlice,

  // Focus Sesh
  focusSesh: focusSeshSlice,
  focusSeshPresets: focusSeshPresetsSlice,
  focusSeshLogs: focusSeshLogsSlice,

  // Teacher:
  classrooms: classroomsSlice,
  students: studentsSlice,
  aiChatThread: aiChatThreadSlice,

  // Admin:
  schools: schoolsSlice,
  districts: districtsSlice,
  teachers: teachersSlice,

  // District Admin:
  district: districtSlice,
  districtSchools: districtSchoolsSlice,
  districtTeachers: districtTeachersSlice,

  // Misc:
  misc: miscSlice
})

const rootReducer = (state: ReturnType<typeof combinedReducer> | undefined, action: AnyAction) => {
  if (action.type === ROOT_ACTIONS.RESET.type) {
    state = undefined
  }
  return combinedReducer(state, action)
}

const store = configureStore({
  reducer: rootReducer,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
